import {useCallback, useMemo} from "react";
import {useLocation} from "react-router";

import {omit} from "@pg-mono/nodash";
import {appendQueryString, parseSearch} from "@pg-mono/request";

import {useTransitioningHistoryPush} from "../../../hooks/use_transitioning_history_push";
import {trackAmplitudeOfferSelectPromotion} from "../../../promotion/tracking/track_amplitude_offer_promotion_events";
import {useAppDispatch} from "../../../store/hooks";
import {resetPrivilegedOfferList} from "../actions/fetch_privileged_offer_list";
import {PRIVILEGE_OFFER_QUERY_PARAM_NAME, PROMOTIONS_QUERY_PARAM_NAME} from "../constants/offer_list";
import {OfferListingPromotionTab} from "../constants/offer_listing_promotion_tabs";
import {getAmplitudeOfferListingPromotionTabSelectTrackingContext} from "../helpers/get_amplitude_offer_listing_promotion_tab_select_tracking_context";
import {isPromotionsListingQuery} from "../helpers/map_offer_list_promotions_query_param";

export type {OfferListingPromotionTab} from "../constants/offer_listing_promotion_tabs";

export const buildOfferListingPromotionTabHref = (pathname: string, hash: string, search: string, tab: OfferListingPromotionTab): string => {
    const nextQuery = omit(parseSearch(search), ["page", PRIVILEGE_OFFER_QUERY_PARAM_NAME]);

    if (tab === "promotions") {
        nextQuery[PROMOTIONS_QUERY_PARAM_NAME] = "1";
    } else {
        delete nextQuery[PROMOTIONS_QUERY_PARAM_NAME];
    }

    return appendQueryString(pathname + hash, nextQuery);
};

export const useOfferListingPromotionTabs = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const {transitionHistory} = useTransitioningHistoryPush();
    const routeQuery = parseSearch(location.search);

    const activeTab: OfferListingPromotionTab = isPromotionsListingQuery(routeQuery) ? "promotions" : "all";

    const tabHrefs = useMemo(
        () => ({
            all: buildOfferListingPromotionTabHref(location.pathname, location.hash, location.search, "all"),
            promotions: buildOfferListingPromotionTabHref(location.pathname, location.hash, location.search, "promotions")
        }),
        [location.hash, location.pathname, location.search]
    );

    const promotionTabsHandler = useCallback(
        (tab: OfferListingPromotionTab) => {
            if (tab === activeTab) {
                return;
            }

            if (tab === "promotions") {
                trackAmplitudeOfferSelectPromotion(getAmplitudeOfferListingPromotionTabSelectTrackingContext());
            }

            dispatch(resetPrivilegedOfferList());
            transitionHistory(tabHrefs[tab]);
        },
        [activeTab, dispatch, tabHrefs, transitionHistory]
    );

    return {
        activeTab,
        tabHrefs,
        promotionTabsHandler
    };
};
import {useCallback, useMemo} from "react";
import {useLocation} from "react-router";

import {omit} from "@pg-mono/nodash";
import {appendQueryString, parseSearch} from "@pg-mono/request";

import {useTransitioningHistoryPush} from "../../../hooks/use_transitioning_history_push";
import {trackAmplitudeOfferSelectPromotion} from "../../../promotion/tracking/track_amplitude_offer_promotion_events";
import {useAppDispatch} from "../../../store/hooks";
import {resetPrivilegedOfferList} from "../actions/fetch_privileged_offer_list";
import {PRIVILEGE_OFFER_QUERY_PARAM_NAME, PROMOTIONS_QUERY_PARAM_NAME} from "../constants/offer_list";
import {OfferListingPromotionTab} from "../constants/offer_listing_promotion_tabs";
import {getAmplitudeOfferListingPromotionTabSelectTrackingContext} from "../helpers/get_amplitude_offer_listing_promotion_tab_select_tracking_context";
import {isPromotionsListingQuery} from "../helpers/map_offer_list_promotions_query_param";

export type {OfferListingPromotionTab} from "../constants/offer_listing_promotion_tabs";

export const buildOfferListingPromotionTabHref = (pathname: string, hash: string, search: string, tab: OfferListingPromotionTab): string => {
    const nextQuery = omit(parseSearch(search), ["page", PRIVILEGE_OFFER_QUERY_PARAM_NAME]);

    if (tab === "promotions") {
        nextQuery[PROMOTIONS_QUERY_PARAM_NAME] = "1";
    } else {
        delete nextQuery[PROMOTIONS_QUERY_PARAM_NAME];
    }

    return appendQueryString(pathname + hash, nextQuery);
};

export const useOfferListingPromotionTabs = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const {transitionHistory} = useTransitioningHistoryPush();
    const routeQuery = parseSearch(location.search);

    const activeTab: OfferListingPromotionTab = isPromotionsListingQuery(routeQuery) ? "promotions" : "all";

    const tabHrefs = useMemo(
        () => ({
            all: buildOfferListingPromotionTabHref(location.pathname, location.hash, location.search, "all"),
            promotions: buildOfferListingPromotionTabHref(location.pathname, location.hash, location.search, "promotions")
        }),
        [location.hash, location.pathname, location.search]
    );

    const promotionTabsHandler = useCallback(
        (tab: OfferListingPromotionTab) => {
            if (tab === activeTab) {
                return;
            }

            if (tab === "promotions") {
                trackAmplitudeOfferSelectPromotion(getAmplitudeOfferListingPromotionTabSelectTrackingContext());
            }

            dispatch(resetPrivilegedOfferList());
            transitionHistory(tabHrefs[tab]);
        },
        [activeTab, dispatch, tabHrefs, transitionHistory]
    );

    return {
        activeTab,
        tabHrefs,
        promotionTabsHandler
    };
};
